/**
 * Shared phone display formatter (DEF-293).
 *
 * Stores digits in forms/API payloads; formats US 10-digit numbers as
 * `(XXX) XXX-XXXX` for display. Anything else passes through unchanged.
 */

/** Strip non-digits from a phone string. */
export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Format a phone for display.
 * - Exactly 10 digits → `(XXX) XXX-XXXX`
 * - 11 digits starting with `1` → `(XXX) XXX-XXXX` (drop country code)
 * - Otherwise → original trimmed value
 */
export function formatPhone(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  const digits = digitsOnly(trimmed);
  const national =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (national.length !== 10) return trimmed;
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}
